// Module
var code = "<template class.bind=\"faded ? 'fader-fade-out' : 'fader-fade-in'\">\n  <slot></slot>\n</template>\n";
// Exports
export default code;